import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class UploadImageResultObject extends BaseModel {
  imageUrl: string;
  imagePath: string;

  constructor(model: Partial<UploadImageResultObject> = {}) {
    super();

    this.imageUrl = model.imageUrl as string;
    this.imagePath = model.imagePath as string;
  }
}
